import type { RecordingChunk } from '@/types'

type TimedChunk = Pick<RecordingChunk, 'index' | 'createdAt' | 'durationMs'>

/**
 * When a recording started, as an ISO-8601 UTC instant, reconstructed from its
 * persisted chunks. Each chunk's `createdAt` marks the moment it was cut (its
 * end), so the start is the first chunk's end minus its duration.
 *
 * Used by the recovery paths that rebuild a draft without the live session's
 * start time. Returns null when no chunk carries a usable timestamp.
 */
export function recordingStartedAt(chunks: readonly TimedChunk[]): string | null {
  const first = [...chunks].sort((a, b) => a.index - b.index)[0]
  if (!first) return null
  const endMs = new Date(first.createdAt).getTime()
  if (Number.isNaN(endMs)) return null
  return new Date(endMs - Math.max(0, first.durationMs || 0)).toISOString()
}
